import React, { useState } from 'react';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '../components/ui/card';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '../components/ui/tabs';
import { 
  Settings, 
  Users,
  ClipboardList,
  FileStack,
  Wallet,
  Briefcase,
  Phone,
  Link2,
  Building2,
  MessageCircle,
  UtensilsCrossed
} from 'lucide-react';

// Import sub-pages as components
import ProgramTypesPage from './ProgramTypesPage';
import EnrollmentTypesPage from './EnrollmentTypesPage';
import FundingSourcesPage from './FundingSourcesPage';
import ServiceTypesPage from './ServiceTypesPage';
import OutboundNumbersPage from './OutboundNumbersPage';
import ProgramServiceMappingsPage from './ProgramServiceMappingsPage';
import OfficeLocationsSettings from '../components/settings/OfficeLocationsSettings';
import MessengerSettings from '../components/settings/MessengerSettings';
import FoodPantryAdminSettingsPage from './FoodPantryAdminSettingsPage';

const SettingsPage = () => {
  const [activeTab, setActiveTab] = useState('program-types');

  const settingsTabs = [
    { id: 'program-types', label: 'Program Types', icon: ClipboardList },
    { id: 'enrollment-types', label: 'Enrollment Types', icon: FileStack },
    { id: 'funding-sources', label: 'Funding Sources', icon: Wallet },
    { id: 'service-types', label: 'Service Types', icon: Briefcase },
    { id: 'service-mappings', label: 'Service Mappings', icon: Link2 },
    { id: 'outbound-numbers', label: 'Outbound Numbers', icon: Phone },
    { id: 'office-locations', label: 'Office Locations', icon: Building2 },
    { id: 'messenger', label: 'HELP Messages', icon: MessageCircle },
    { id: 'food-pantry', label: 'Food Pantry', icon: UtensilsCrossed },
  ];

  return (
    <div className="space-y-6" data-testid="settings-page">
      <div className="flex items-center gap-3">
        <Settings className="w-8 h-8 text-primary" />
        <div>
          <h1 className="text-2xl font-bold text-gray-900">Settings</h1>
          <p className="text-gray-500">Configure system settings and maintain the CRM</p>
        </div>
      </div>

      <Tabs value={activeTab} onValueChange={setActiveTab} className="space-y-6">
        <TabsList className="flex flex-wrap gap-2 h-auto p-2 bg-muted/50">
          {settingsTabs.map((tab) => {
            const Icon = tab.icon;
            return (
              <TabsTrigger 
                key={tab.id} 
                value={tab.id}
                className="flex items-center gap-2 data-[state=active]:bg-white"
                data-testid={`settings-tab-${tab.id}`}
              >
                <Icon className="w-4 h-4" />
                {tab.label}
              </TabsTrigger>
            );
          })}
        </TabsList>

        <TabsContent value="program-types">
          <ProgramTypesPage />
        </TabsContent>

        <TabsContent value="enrollment-types">
          <EnrollmentTypesPage />
        </TabsContent>

        <TabsContent value="funding-sources">
          <FundingSourcesPage />
        </TabsContent>

        <TabsContent value="service-types">
          <ServiceTypesPage />
        </TabsContent>

        <TabsContent value="service-mappings">
          <ProgramServiceMappingsPage />
        </TabsContent>

        <TabsContent value="outbound-numbers">
          <OutboundNumbersPage />
        </TabsContent>

        <TabsContent value="office-locations">
          <OfficeLocationsSettings />
        </TabsContent>

        <TabsContent value="messenger">
          <MessengerSettings />
        </TabsContent>

        <TabsContent value="food-pantry">
          <FoodPantryAdminSettingsPage />
        </TabsContent>
      </Tabs>
    </div>
  );
};

export default SettingsPage;
